export const fontSize = {
  xxs: '12px',
  xs: '16px',
  sm: '21px',
  md: '25px',
  lg: '37px',
  xl: '50px',
  xxl: '55px',
};
